import FlourishDeck from "./FlourishDeck";

const ForumRcpProposal = () => <FlourishDeck partner="forumrcp" />;

export default ForumRcpProposal;